export default (props, vars) =>
  `Upon receipt of your acceptance, we'll enroll you in the ${vars?.['useapplicationoffer2']?.['applicationOffer'].terms.type} and you'll receive access to the Extern Student App Platform where all training, work input, and feedback will be conducted.`;
